import dayjs from "dayjs";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

export const combine = (date, time) => (date && time ? `${date} ${time.length === 5 ? time + ":00" : time}` : null);
export const timeOf = (dt) => (dt ? dayjs(dt).format("HH:mm") : "");

// Round a "HH:MM" string to the nearest 15-minute interval.
export const snapTo15 = (t) => {
  if (!t || t.length < 4 || !t.includes(":")) return t;
  const [h, m] = t.split(":").map(Number);
  if (Number.isNaN(h) || Number.isNaN(m)) return t;
  let total = h * 60 + Math.round(m / 15) * 15;
  total = ((total % 1440) + 1440) % 1440;
  const hh = String(Math.floor(total / 60)).padStart(2, "0");
  const mm = String(total % 60).padStart(2, "0");
  return `${hh}:${mm}`;
};

export const SectionLabel = ({ children }) => (
  <div className="text-[10px] font-bold uppercase tracking-wider text-slate-400 mb-2">{children}</div>
);

export const Field = ({ label, children }) => (
  <div><Label className="text-[11px] font-medium text-slate-600 mb-1 block">{label}</Label>{children}</div>
);

// ─── 15-minute interval time select ───────────────────────────────────────────
// Generates 96 quarter-hour slots (00:00 → 23:45) and renders them as a
// <Select> dropdown.  The stored value is always a plain "HH:MM" string so
// nothing downstream needs to change.  If an existing value doesn't land on a
// 15-min boundary it is shown verbatim via <SelectValue> until the user picks
// a new slot.
const TIME_OPTIONS = (() => {
  const opts = [];
  for (let h = 0; h < 24; h++) {
    for (const m of [0, 15, 30, 45]) {
      const hh = String(h).padStart(2, "0");
      const mm = String(m).padStart(2, "0");
      opts.push(`${hh}:${mm}`);
    }
  }
  return opts;
})();

export function TimeSelect({ value, onChange, disabled, className = "", "data-testid": testid }) {
  // Normalise stored value to "HH:MM" (strip seconds if present).
  const display = value ? String(value).slice(0, 5) : "";

  return (
    <Select value={display} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger className={`h-9 text-sm ${className}`} data-testid={testid}>
        <SelectValue placeholder="--:--" />
      </SelectTrigger>
      <SelectContent className="max-h-64 overflow-y-auto">
        {TIME_OPTIONS.map((t) => (
          <SelectItem key={t} value={t} className="text-sm font-mono">
            {t}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
